<template>
    <div>
        <card :item="item" :type="type" :isLaborCompany='true'>
            <div class="cardbody" @click="goDetails">
                    <div class="header color3">
                        <div class="header-title" style="color: #333;max-width:480px" :title="item.name">{{item.name}}</div>
                    </div>
                <div class="content">
                    <el-row :gutter="20">
                        <el-col :span="12" class="single_hide contents">
                            <span class="color6">注册资金:</span>
                            <span class="color3">{{item.registeredCapital ||'/'}}</span>
                        </el-col>
                        <el-col :span="12" class="single_hide contents">
                            <span class="color6">统一社会信用代码:</span>
                            <span class="color3" :title="item.creditCode">{{item.creditCode ||'/'}}</span>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <!-- <el-col :span="12" class="single_hide">
                        <span class="color6">企业类型:</span>
                            <span class="color3">
                                {{item.companyType ? item.companyType : "--"}}
                            </span>
                        </el-col> -->
                        <el-col :span="12" class="single_hide contents">
                            <span class="color6">法定代表人:</span>
                            <span class="color3">{{item.legalRepresentative ||'/'}}</span>
                        </el-col>
                        <el-col :span="12" class="single_hide contents">
                            <span class="color6">注册地:</span>
                            <span class="color3" :title="item.districtName?item.provinceName + item.cityName + item.districtName:item.provinceName + item.cityName">{{item.districtName?item.provinceName + item.cityName + item.districtName:item.provinceName + item.cityName}}</span>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="12" class="single_hide contents">
                            <span class="color6">成立时间:</span>
                            <span class="color3">{{item.establishmentDate&&item.establishmentDate!=0 ?dateFormat(Number(item.establishmentDate)) :"--" }}</span>
                        </el-col>
                        <el-col :span="12" class="single_hide contents" style="padding:0 10px">
                            <span class="color6">班组数量:</span>
                            <span class="color3">{{item.teamNum||'/'}}</span>
                        </el-col>
                    </el-row>
                    <el-table
                        :header-cell-style="setColumnDataColor"
                        :cell-style="setCellStyle"
                        style="width: 100%;min-height:70px;margin:0 2px;"
                        :data="item.qualificationList.slice(0,1)"
                        >
                        <div slot="empty">
                            <p class="noText" style="color:#666666;fontSize:14px;background:#FAFAFA;height:34px;line-height:34px">暂无数据</p>
                        </div>
                        <el-table-column  label="资质类型" prop="type" show-overflow-tooltip width="100"></el-table-column>
                        <el-table-column  label="劳务资质等级" prop="level" show-overflow-tooltip width="120"></el-table-column>
                        <el-table-column  label="劳务资质号" prop="code" show-overflow-tooltip width="150"></el-table-column>
                        <el-table-column  label="资质发证单位" prop="unit" show-overflow-tooltip></el-table-column>
                    </el-table>
                </div>
        
                <!-- <div class="footer">
                    <div class="time">
                        <span class="color6">成立时间:</span>
                        <span style="color:#969696;">
                            {{ item.establishmentDate&&item.establishmentDate!=0 ? dateFormat(Number(item.establishmentDate)) : "--" }}
                        </span>
                    </div>
                    <div class="detail">查看详情</div>
                </div> -->
            </div>
        </card>
    </div>
</template>

<script>

export default {
    name: "cardLaborServiceCompany",
    components: {
        card: () => import("@/components/card/card"),
    },
    props: {
        item: Object,
        type: Number, // 1 工队 2 工程 3 工人 4 招工用工 5 工种报价 6劳务用工
    },
    data(){
        return{
        tableData: [],
        }
    },
  methods: {
    //跳转详细
    goDetails(){
      let routeUrlC = `${process.env.VUE_APP_MATERIALSURL}/company/?no=${this.item.no}&type=1&subMenuId=7`
      window.open(routeUrlC, "_blank")
        }
    }
}
</script>

<style lang="scss" scoped>
.cardbody{
    cursor: pointer;
    .header {
        padding: 0 10px;
        height: 40px;
        font-size: 16px;
        line-height: 40px;
        background-color: #f5f7fa;
        border-bottom: 1px solid #e4e7ed;
      .header-title{
        white-space:nowrap;
        text-overflow:ellipsis;
        overflow:hidden;
      }
    }
    .content {
        padding: 10px;
        line-height: 28px;
        // border-bottom: 1px dashed #e4e7ed;
        .contents{
            height: 19px;
            line-height: 19px;
            margin-bottom: 10px;
        }
    }
    .footer {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 15px;
        height: 40px;
        .detail {
            padding: 4px 8px;
            border: 1px solid #b79255;
            color: #b79255;
        }
    }
}
/deep/.el-table th, .el-table tr{
    height: 34px;
    padding: 0;
}
/deep/.el-table{
    margin-top: 5px;
    .el-table__empty-block{
        min-height: 34px;
        width: 100%;
        display: block;
    }
    tr{
        background: #FAFAFA!important;
    }
    .el-table__cell{
        height: 34px!important;
        padding: 0!important;
        // &:last-child{
        //     border-bottom: none;
        // }
    }
}
/deep/.el-table__row>td{
  /* 去除表格线 */
  border: none;
}
.el-table::before{
    height: 0px;
}

.single_hide {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
div {
    box-sizing: border-box;
}
.color6 {
    color: #666666;
}
.color3 {
    color: #333333;
}
</style>
